import { render, staticRenderFns } from "./Rodape.vue?vue&type=template&id=083ded76&scoped=true"
import script from "./Rodape.vue?vue&type=script&lang=ts"
export * from "./Rodape.vue?vue&type=script&lang=ts"
import style0 from "./Rodape.vue?vue&type=style&index=0&id=083ded76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ded76",
  null
  
)

export default component.exports